import styled from '@emotion/styled';
import { Button, ButtonProps } from 'antd';

const Btn = styled(Button)`
  padding: 0;
  height: inherit;
  font-size: 12px;
`;

const TextButton = (props: ButtonProps) => {
  return <Btn type="text" {...props} />;
};

export default TextButton;
